import { getGeocodeCached } from 'shared/services/getGeocodeCached';
import { toLoggableError } from 'shared/errors';
import { IApplicationContext } from 'shared/types/applicationContext';
import { loadYmapsApi } from 'shared/utils/ymaps';

function yandexGeocode(request: string, options?: YMaps.IGeocodeOptions) {
  return loadYmapsApi({ require: ['geocode'] })
    .then(ymaps => ymaps.geocode(request, options))
    .then(items => items || []);
}

const geocodeDirect = ({ logger }: IApplicationContext, value: string) =>
  yandexGeocode(value)
    .then(result => {
      return result.geoObjects.toArray().map(geoObject => {
        return {
          text: geoObject.properties.get('text') as string,
          name: geoObject.properties.get('name') as string,
          kind: geoObject.properties.get('metaDataProperty.GeocoderMetaData.kind') as YMaps.TGeoKind,
          coordinates: (geoObject.geometry && geoObject.geometry.getCoordinates()) || [0, 0],
          boundedBy: geoObject.properties.get('boundedBy') as [YMaps.TCoord, YMaps.TCoord],
        };
      });
    })
    .catch(err => {
      logger.error(toLoggableError(err, { type: 'YandexGeocodeError', domain: 'critical.yandexGeocode' }), {
        degradation: 'Запрос гео-кода из Яндекса',
        initiator: 'yandexApi',
      });
    });

const geocodeCached = (context: IApplicationContext, value: string) =>
  getGeocodeCached(context, { request: value }).catch(err => {
    context.logger.error(err, {
      degradation: 'Запрос гео-кода из кэша',
      domain: 'critical.geocodeCached',
      microserviceName: 'geo-suggest',
      pathApi: '/public/v1/geocode-cached/',
      parameters: JSON.stringify({ request: value }),
    });

    throw err;
  });

export const geocode = (context: IApplicationContext, value: string) =>
  geocodeCached(context, value).catch(() => geocodeDirect(context, value));
